import { makeStyles } from '@material-ui/core';
import { neutral, orange } from '../../../../../../../shared/styles/colors';

export default makeStyles(() => ({
  suggestionsContainer: {
    backgroundColor: orange[10],
    borderLeft: `3px solid ${orange[60]}`,
  },
  suggestionContainer: {
    padding: 0,
    paddingLeft: '1rem',
    listStyle: 'disc',
  },
  suggestionItem: {
    color: neutral[80],
    display: 'list-item',
    fontSize: '0.5rem',
    padding: 0,
  },
  suggestionDisclaimer: {
    fontFamily: 'PP Object Sans',
    color: `${neutral[100]}`,
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  suggestionUnits: {
    fontFamily: 'PP Object Sans',
    color: neutral[80],
    fontWeight: 500,
    fontSize: '0.75rem',
  },
  suggestionName: {
    fontFamily: 'PP Object Sans',
    color: neutral[80],
    fontWeight: 500,
    fontSize: '0.75rem',
  },
  suggestionPrice: {
    color: `${neutral.D16}`,
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  disclaimerContent: {
    backgroundColor: orange[10],
    paddingTop: '0.5rem',
  },
  disclaimerTitle: {
    color: neutral.D18,
    fontSize: '0.875rem',
    fontWeight: 600,
    marginLeft: '0.5rem',
    paddingBottom: '0.5rem',
    borderBottom: `1px solid ${neutral.D10}`,
  },
  disclaimerIcon: {
    alignSelf: 'flex-start',
  },
  disclaimerDescription: {
    color: neutral[80],
    fontFamily: 'PP Object Sans',
    fontSize: '0.75rem',
    fontWeight: 500,
  },
}));
